export const PROFILE_ROUTE = '/profile';
export const ACCOUNT_SELECTION_ROUTE = '/selection-type-account';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';